import { render } from "./XIconSolidWarehouse.vue?vue&type=template&id=2b86c896"
import script from "./XIconSolidWarehouse.vue?vue&type=script&lang=js"
export * from "./XIconSolidWarehouse.vue?vue&type=script&lang=js"

import exportComponent from "/home/omid_es327/Projects/erp/laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"XIconSolidWarehouse.vue"]])

export default __exports__